import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from 'context/UserContext';

function Index() {
  const user = useUser();
  return (
    <>
      {/*<ul className="nav nav-pills">
        {user.permissions.Admin && (
          <>
            <li className="nav-item">
              <NavLink className="nav-link" data-toggle="tab" to="User">Users</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" data-toggle="tab" to="Agency">Agencies</NavLink>
            </li>
            <li className="nav-item">
                <NavLink className="nav-link" data-toggle="tab" to="FailedRegistrations">Failed Registrations</NavLink>
            </li>
          </>
        )}
        {user.permissions.InformationServices && (
          <li className="nav-item">
              <NavLink className="nav-link" data-toggle="tab" to="Profiles">Security Profiles</NavLink>
          </li>
        )}
        {user.permissions.MailRoom && (
          <li className="nav-item">
              <NavLink className="nav-link" data-toggle="tab" to="MailRoom">Mail Room</NavLink>
          </li>
        )}
      </ul>*/}
    </>
  );
}

export function GetDefault() {
  const user = useUser();
  if (user.permissions.Admin) {
    return <Navigate to="/Admin/User" />;
  }
  if (user.permissions.InformationServices) {
    return <Navigate to="/Admin/Profiles" />;
  }
  if (!user.permissions.Admin && user.permissions.MailRoom) {
    return <Navigate to="/Admin/MailRoom" />;
  }
}

export { Index };
